/**
 * today, 
 * pos_customer_credit_option_id, 
 * pos_sale_type_id, 
 * g_seller_user_id, 
 * g_supervisor_user_id, 
 * g_cashier_user_id, 
 * g_branch_office_id, 
 * wh_product_id, 
 * g_branch_office_of_cash_desk_id, 
 * inventory_editable, 
 * pos_cash_desk_id, 
 * pos_manual_discount_id, 
 * wh_sale_note_id, 
 * sl_customer_id, 
 * pos_sale_note_id, 
 * g_state_id, 
 * pos_origin_sale_id, 
 * created_at_min, 
 * created_at_max`
 */

//
import BranchOfficeModel from '@/models/General/GBranchOffice'
import CashDeskModel from '@/models/POS/PosCashDesk'
import CustomerModel from '@/models/Sale/SlCustomer'
import CustomerCreditOptionModel from '@/models/POS/PosCustomerCreditOption'
import SaleTypeModel from '@/models/POS/PosSaleType'
import StateModel from '@/models/General/GState'
import UserModel from '@/models/General/GUser'

//
export default ({ g_branch_office_address }) => [
    {
        name: 'sl_customer_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Cliente',
            model: CustomerModel,
            noObject: true,
            paramSearch: 'search',
        },
    },
    {
        name: 'pos_cash_desk_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name_case',
            itemValue: 'id',
            label: 'Caja',
            model: CashDeskModel,
            noAsyncSearch: true,
            noObject: true,
            paramSearch: 'name',
        },
    },
    {
        name: 'g_branch_office_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            model: BranchOfficeModel,
            noObject: true,
            paramFilter: {
                address: g_branch_office_address,
            },
            paramSearch: 'address',
        },
    },
    {
        name: 'g_cashier_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Cajero',
            model: UserModel,
            noObject: true,
            paramFilter: {
                cashier_user: '1',
            },
        },
    },
    {
        name: 'g_supervisor_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noObject: true,
            paramFilter: {
                pos_supervisor_user: '1',
            },
        },
    },
    {
        name: 'g_seller_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Vendedor',
            model: UserModel,
            noObject: true,
            paramFilter: {
                seller_user: '1',
            },
        },
    },
    {
        name: 'pos_sale_type_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: SaleTypeModel,
            noObject: true,
            paramSearch: 'type',
        },
    },
    {
        name: 'pos_customer_credit_option_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'credit_option',
            itemValue: 'id',
            label: 'Crédito',
            model: CustomerCreditOptionModel,
            noAsyncSearch: true,
            noObject: true,
            paramSearch: 'credit_option',
        },
    },
    {
        name: 'g_state_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'state',
            itemValue: 'id',
            label: 'Estado',
            model: StateModel,
            noObject: true,
            paramFilter: {
                g_state_type_id: 8,
            },
            paramSearch: 'state',
        },
    },
    {
        name: 'created_at_min',
        type: 'date-field',
        props: {
            label: 'Desde',
        },
    },
    {
        name: 'created_at_max',
        type: 'date-field',
        props: {
            label: 'Hasta',
        },
    },
]
